'use client';

import classNames from '@sindresorhus/class-names';
import {useState} from 'react';

import {Chevron} from './assets/Chevron';
import {Sort} from './assets/Sort';
import {Modal} from './parts/Modal/Modal';
import styles from './SelectModal.module.scss';

export type SelectItem<T = string | number> = {
  title: string;
  description?: string;
  value: T;
};

// Определяем тип SelectModalProps с дженериком
type SelectModalProps<T = string | number> = {
  defaultValue: SelectItem<T>;
  currentValue?: SelectItem<T>;
  leftIcon?: React.ReactNode;
  values: Array<SelectItem<T>>;
  onSelect?: (item: SelectItem<T>, index: number) => void;
  onOpen?: (state: boolean) => void;
  dataTestIdPrefix?: string;
};

export const SelectModal = <T,>({
  defaultValue,
  leftIcon = <Sort />,
  values,
  onSelect,
  onOpen,
  currentValue,
  dataTestIdPrefix = '',
}: SelectModalProps<T>) => {
  const [value, setValue] = useState<SelectItem<T>>(
    currentValue || defaultValue,
  );
  const [isOpened, setOpened] = useState(false);

  const onOpenState = () => {
    onOpen?.(true);
    setOpened(true);
  };
  const onCloseState = () => {
    onOpen?.(false);
    setOpened(false);
  };

  const onChangeValue = (item: SelectItem<T>, index: number) => {
    setValue(item);
    onSelect?.(item, index);
  };

  return (
    <div
      className={classNames(styles.select, {
        [styles.select__opened]: isOpened,
        [styles.select__active]: value.value !== defaultValue.value,
      })}
      onClick={onOpenState}
      data-testid={dataTestIdPrefix + '_selectModal'}
    >
      <span className={styles.select__sortIcon}>{leftIcon}</span>
      {value.title}
      <Chevron className={classNames(styles.select__chevron)} />
      {isOpened && (
        <Modal
          currentValue={value}
          onChangeValue={onChangeValue}
          values={values}
          onCloseModal={onCloseState}
        />
      )}
    </div>
  );
};
